<template>
  <div class="preload-logo">
    <img src="/images/logo.png" height="60" width="60"/>
    <span style=" margin-top:12px; color: #ffa900;">
      <b style="color: #275fcb; margin-left: 12px;"> Salework </b>
      Chat</span>
    <!--    <img src="../../../public/images/image-load.png" height="400" width="800" class="mt-5"/>-->
  </div>
</template>

<script>
export default {
  name: "LoadingView"
}
</script>

<style scoped>
.preload-logo {
  height: calc(100vh - 16px);
  width: calc(100vw - 16px);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 30px;
  line-height: 32px;
  font-family: Arial, Helvetica, sans-serif;
}

</style>